import React, { memo } from 'react';

import List from '../../../../../List';
import Bill from '../../../../../Bill';

function BillsLists({
  billPayment,
  billLineItemIds,
  setBillLineItemIds,
  isBillPaymentFullyApplied,
  unpaidBills,
  refetch,
}) {
  return (
    <>
      <div className="mb-10">
        <List
          title="Bills"
          items={billPayment?._bills?.map((bill) => ({
            key: bill.id,
            content: (
              <Bill
                billPaymentSentpayId={billPayment?.billcom_sentpay_id}
                bill={bill}
                billLineItemIds={billLineItemIds}
                setBillLineItemIds={setBillLineItemIds}
                refetch={refetch}
              />
            ),
          }))}
        />
      </div>
      {!isBillPaymentFullyApplied && (
        <List
          title="Unpaid Bills"
          items={unpaidBills?.map((bill) => ({
            key: bill.id,
            content: (
              <Bill
                bill={bill}
                billLineItemIds={billLineItemIds}
                setBillLineItemIds={setBillLineItemIds}
              />
            ),
          }))}
        />
      )}
    </>
  );
}

export default memo(
  BillsLists /* (prevProps, nextProps) => {
  const keys = Object.keys({ ...prevProps, ...nextProps });
  const changedProps = keys.filter((key) => prevProps[key] !== nextProps[key]);

  if (changedProps.length > 0) {
    console.log('Changed props:', changedProps);
    return false; // props are not equal, so re-render
  }

  return true; // props are equal, no need to re-render
} */
);
